<div [class.clickable]="!showTable" (click)="showTableDialog()">
    <h3>Incomplete Reports <span>{{count}}</span></h3>
    @if (!isLoading) {
    <div class="incomplete">
        @if (!showTable && submitTimeDays) {
        <div>
            <p>Average time to submit: {{submitTimeDays}}</p>
        </div>
        }
        @if (!noData && showTable) {
        <table class="table table-striped table-fixed">
            @if (showInterviewer) {
            <thead class="sortable-header">
                <tr>
                    <th [ngClass]="sortType('name')" class="appname" sortableiir="name" (sort)="onSort($event)">Name
                    </th>
                    <th [ngClass]="sortType('interviewerName')" sortableiir="interviewerName" (sort)="onSort($event)">
                        Interviewer</th>
                    <th [ngClass]="sortType('countryCode')" class="country" sortableiir="countryCode"
                        (sort)="onSort($event)">Country</th>
                    <th [ngClass]="sortType('interviewDateTime')" class="date" sortableiir="interviewDateTime"
                        (sort)="onSort($event)">Date</th>
                    <th class="state">Status</th>
                </tr>
            </thead>
            }
            <tbody>
                @for (a of softedFilteredList; track a) {
                <tr class="applicant" (click)="openApplicant(a)">
                    <td class="appname">
                        <span class="profile-image">
                            <app-cf-profile [urlOrInitials]="a.profile" [width]="30" [height]="30"></app-cf-profile>
                        </span>
                        <span class="warnings">
                            @if (a.status > 0) {
                            <span container="body" ngbPopover="{{a.statusInfo}}" popoverClass="slot-popover"
                                triggers="mouseenter:mouseleave" popoverTitle="Note"><i
                                    class="warning fa-solid fa-circle-exclamation"></i></span>
                            }
                        </span>
                        {{a.name}}
                    </td>
                    @if (showInterviewer) {
                    <td class="interviewer">{{a.interviewerName}}</td>
                    <td class="country">{{a.countryCode}}</td>
                    }
                    <td class="date">{{a.date}}</td>
                    <td class="state">{{a.userState}}</td>
                </tr>
                }
            </tbody>
        </table>
        }
        <!-- <div @if (noData) {<p>No incomplete interview reports.</p></div> -->
    </div>
    } @else {
    <div class="loading">
        <div class="load_container">
            <app-cf-loader></app-cf-loader>
        </div>
    </div>
    }